import { Link } from "react-router-dom";

export const RegisterLayout = ({ kicker, title, subtitle, children }) => (
  <div className="min-h-screen bg-[#070707] text-[#F5F5F0]">
    <div className="border-b border-white/10 sticky top-0 z-40 bg-black/70 backdrop-blur-xl">
      <div className="max-w-[1100px] mx-auto px-6 py-5 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-3">
          <img src="/logo-mark.png" alt="Vinci" className="h-7 w-auto" />
          <span className="font-serif text-xl">Vinci Inc.</span>
        </Link>
        <Link to="/login" className="font-grotesk text-xs uppercase tracking-[0.2em] text-[#C9C9C2] hover:text-[#F5F5F0] transition-colors">Sign in</Link>
      </div>
    </div>
    <div className="max-w-[1100px] mx-auto px-6 py-14 md:py-20">
      <span className="overline text-[#B87333]">{kicker}</span>
      <h1 className="font-serif text-4xl md:text-6xl mt-4 tracking-[-0.02em]">{title}</h1>
      {subtitle && <p className="font-body text-[#8A8A82] mt-4 max-w-xl leading-relaxed">{subtitle}</p>}
      <div className="mt-12">{children}</div>
    </div>
  </div>
);

export const Input = ({ label, testid, className = "", ...props }) => (
  <label className={`block group ${className}`}>
    <span className="overline text-[#8A8A82] group-focus-within:text-[#B87333] transition-colors">{label}{props.required && " *"}</span>
    <input
      data-testid={testid}
      {...props}
      className="w-full bg-transparent border-b border-white/15 focus:border-[#B87333] outline-none py-3 mt-2 font-body text-lg text-[#F5F5F0] transition-colors"
    />
  </label>
);

export const Textarea = ({ label, testid, className = "", ...props }) => (
  <label className={`block group ${className}`}>
    <span className="overline text-[#8A8A82] group-focus-within:text-[#B87333] transition-colors">{label}{props.required && " *"}</span>
    <textarea
      data-testid={testid}
      {...props}
      className="w-full bg-transparent border-b border-white/15 focus:border-[#B87333] outline-none py-3 mt-2 font-body text-lg text-[#F5F5F0] transition-colors resize-none"
    />
  </label>
);

export const SubmitButton = ({ children, testid, ...props }) => (
  <button
    data-testid={testid}
    {...props}
    className="group inline-flex items-center gap-4 rounded-full bg-[#F5F5F0] text-black pl-8 pr-3 py-4 font-grotesk text-xs uppercase tracking-[0.2em] hover:bg-[#B87333] transition-colors duration-300 disabled:opacity-50"
  >
    {children}
    <span className="grid place-items-center w-9 h-9 rounded-full bg-black text-[#F5F5F0] group-hover:rotate-45 transition-transform duration-300">↗</span>
  </button>
);
